export default <T extends { id: string }>(array: T[]): { [key: string]: T } =>
  array.reduce((acc: { [key: string]: T }, el: T) => {
    acc[el.id] = el;
    return acc;
  }, {} as { [key: string]: T });
